import {
  PREFERENCES_REQUEST,
  PREFERENCES_SUCCESS,
  UPDATE_PREFERENCES_REQUEST,
  UPDATE_PREFERENCES_SUCCESS,
  REQUEST_FAILURE,
  SET_SOLARGRAF_ACCESS,

  PREFERENCES_WITHOUT_SITES_REQUEST,
  PREFERENCES_WITHOUT_SITES_SUCCESS,
  REQUEST_WITHOUT_SITES_FAILURE,

  //  USER OWN PREFERENCES
  GET_USER_OWN_PREFERENCES_REQUEST,
  GET_USER_OWN_PREFERENCES_FAILURE,
  GET_USER_OWN_PREFERENCES_SUCCESS
} from './constants';

import { get } from '../../utils/lodash';

let initialState = {
  message: '',
  messageType: '',
  preferencesData: {},
  masterData: {},
  alertPreferencesBySystem: [],
  currentlySending: false,
  solargrafAccess: false,
  preferenceLoading: false,

  masterDataWithoutSites: {},
  preferencesDataWithoutSites: {},

  //  USER OWN PREFERENCES
  currentlySendingForUserOwn: false
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case PREFERENCES_REQUEST:
      return { ...state, currentlySending: true, preferenceLoading: true };
    case UPDATE_PREFERENCES_REQUEST:
      return { ...state, currentlySending: true };
    case UPDATE_PREFERENCES_SUCCESS:
      return {
        ...state,
        message: action.message,
        preferencesData: {
          ...state.preferencesData,
          preferred_new_notification_view: get(action, 'body.account.preferred_new_notification_view')
        },
        preferencesDataWithoutSites: {
          ...state.preferencesDataWithoutSites,
          preferred_new_notification_view: get(action, 'body.account.preferred_new_notification_view')
        },
        alertPreferencesBySystem: [],
        messageType: 'success',
        currentlySending: false
      };
    case PREFERENCES_SUCCESS:
      return {
        ...state,
        preferencesData: {
          ...state.preferencesData,
          ...action.preferencesData
        },
        masterData: action.masterData,
        alertPreferencesBySystem: action.alertPreferencesBySystem,
        currentlySending: false,
        preferenceLoading: false
      };
    case REQUEST_FAILURE:
      return {
        ...state,
        message: action.error,
        messageType: 'error',
        currentlySending: false,
        preferenceLoading: false
      };

    case PREFERENCES_WITHOUT_SITES_REQUEST:
      return { ...state };
    case PREFERENCES_WITHOUT_SITES_SUCCESS:
      return {
        ...state,
        preferencesDataWithoutSites: {
          ...state.preferencesDataWithoutSites,
          ...action.preferencesDataWithoutSites
        },
        masterDataWithoutSites: action.masterDataWithoutSites
      };  
    case REQUEST_WITHOUT_SITES_FAILURE:
      return {
        ...state,
        message: action.error,
        messageType: 'error'
      };

    //  USER OWN PREFERENCES
    case GET_USER_OWN_PREFERENCES_REQUEST:
      return { ...state, currentlySendingForUserOwn: true };
    case GET_USER_OWN_PREFERENCES_SUCCESS:
      return {
        ...state,
        preferencesData: {
          ...state.preferencesData,
          ...action.preferencesData
        },
        solargrafAccess: action.solargrafAccess,
        currentlySendingForUserOwn: false
      };
    case GET_USER_OWN_PREFERENCES_FAILURE:
      return { ...state, message: action.error, messageType: 'error', currentlySendingForUserOwn: false };
    case SET_SOLARGRAF_ACCESS:
      return { ...state, solargrafAccess: action.solargrafAccess };

    default:
      return state;
  }
}

export default reducer;
